import { useEffect, useState } from "react";

export default function ViewContract({ contract }) {
  const [contractId, setContractId] = useState("");
  const [contractName, setContractName] = useState("");
  const [signingDate, setSigningDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [artworks, setArtworks] = useState([]);
  const [contractImages, setContractImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (!contract) return;

    setContractId(contract.contractId);
    setContractName(contract.contractName);
    setSigningDate(
      contract.signingDate ? contract.signingDate.split("T")[0] : "",
    );
    setExpiryDate(contract.expiryDate ? contract.expiryDate.split("T")[0] : "");

    setArtworks(contract.artworks ?? []);
    setContractImages(contract.contractImageUrl ?? []);
  }, [contract]);

  return (
    <form className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">
        Contract Details
      </h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Contract ID
        </label>
        <input
          type="text"
          value={contractId}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Contract Name
        </label>
        <input
          type="text"
          value={contractName}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Signing Date
        </label>
        <input
          type="date"
          value={signingDate}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Expiry Date
        </label>
        <input
          type="date"
          value={expiryDate}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Artworks
        </label>
        {artworks.length > 0 ? (
          artworks.map((art, idx) => (
            <input
              key={idx}
              type="text"
              value={art}
              readOnly
              className="w-full mb-2 rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-gray-100 cursor-not-allowed"
            />
          ))
        ) : (
          <input
            type="text"
            value="No artworks"
            readOnly
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-gray-100 cursor-not-allowed"
          />
        )}
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-2">
          Contract Images
        </label>
        <div className="flex flex-wrap gap-2">
          {contractImages.length > 0 ? (
            contractImages.map((img, idx) => {
              const imgUrl = `${process.env.REACT_APP_API_URL}${img}`;
              return (
                <img
                  key={idx}
                  src={imgUrl}
                  alt={`Contract ${idx + 1}`}
                  className="w-20 h-20 object-cover rounded cursor-pointer hover:scale-105 transition"
                  onClick={() => setSelectedImage(imgUrl)}
                />
              );
            })
          ) : (
            <span className="text-gray-500">No images available</span>
          )}
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Preview"
            className="max-h-[90%] max-w-[90%] rounded-lg shadow-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-5 right-5 text-white text-2xl font-bold"
          >
            ×
          </button>
        </div>
      )}
    </form>
  );
}
